import { HeaderOrderSuccess } from 'ui/components';
import { HeaderLogo } from 'ui/containers/SectionBuilder/sections/Header/widgets';

const HeaderWidget = () => (
  <HeaderOrderSuccess>
    <HeaderLogo />
  </HeaderOrderSuccess>
);

export default HeaderWidget;
